export * from './fastGrowingCompaniesQuery';